<template>
    <div>
        <div
            v-if="data"
            class="flex space-between mb-4"
            style="flex-wrap: wrap"
        >
            <div
                class="review_grid mt-2"
                v-for="item in data"
                :key="item.user.id"
            >
                <div>
                    <div>
                        <div class="flex space-between review_list">
                            <div>
                                <img
                                    alt=""
                                    :src="item.user.image?item.user.image.thumbnail:userimage"
                                    class="review_list_img"
                                />
                            </div>
                            <div style="width: 70%" class="ml-3 mr-4">
                                <div class="flex space-between">
                                    <small style="font-size: 14px">{{
                                        item.user.full_name
                                    }}</small>
                                    <v-spacer />
                                    <small
                                        style="font-size: 10px; color: #949494"
                                        ><time-ago
                                            :datetime="item.created_at"
                                            long
                                    /></small>
                                </div>
                                <div
                                    class="flex"
                                    style="max-height: 50px !important"
                                >
                                    <small class="description">
                                        {{ item.review }}
                                    </small>
                                    <v-spacer />
                                </div>
                            </div>
                            <div>
                                <div
                                    v-if="item.rating < 3"
                                    class="flex star_icon"
                                >
                                    <v-icon color="#E15D5D" size="12"
                                        >mdi-star</v-icon
                                    >
                                    <small
                                        class="ml-1"
                                        style="color: #e15d5d"
                                        >{{ item.rating }}</small
                                    >
                                </div>
                                <div
                                    v-if="item.rating == 3"
                                    class="flex star_icon"
                                >
                                    <v-icon color="#D1C026" size="12"
                                        >mdi-star</v-icon
                                    >
                                    <small
                                        class="ml-1"
                                        style="color: #d1c026"
                                        >{{ item.rating }}</small
                                    >
                                </div>
                                <div
                                    v-if="item.rating > 3"
                                    class="flex star_icon"
                                >
                                    <v-icon color="#30A46C" size="12"
                                        >mdi-star</v-icon
                                    >
                                    <small
                                        class="ml-1"
                                        style="color: #30a46c"
                                        >{{ item.rating }}</small
                                    >
                                </div>
                                <button
                                    class="see_more_btn"
                                    :disabled="item.review==null"
                                    @click="showReplyCommentDialog(item)"
                                >
                                    See More
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
               
            </div>
        </div>
         <reply-comment ref="replyCommentRef" />
    </div>
</template>

<script>
import { TimeAgo } from "vue2-timeago";

import replyComment from "../components/reply-comment.vue";
export default {
    name: "reviewList",
    components: {
        "time-ago":TimeAgo,
        "reply-comment": replyComment,
    },
    data() {
        return {
            userimage:  require("../../../../assets/DummyAvatar.png"),
            reviewData:null
        };
    },
    props: {
        data: {
            type: Array,
        },
    },
    methods: {
        showReplyCommentDialog(item) {
         console.log(item)
        
            this.$refs.replyCommentRef.userData = item;
            this.$refs.replyCommentRef.replyCommentDialog = true;
         
        },
    },
};
</script>

<style scoped>
.review_grid {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 2px;
    background-color: white;
    width: 49%;
    justify-content: space-between;
    margin: 0.2rem;
    border-radius: 2px;
}
.review_list {
    padding: 0.6rem;
    align-items: flex-start;
}
.review_list_img {
    height: 50px !important;
    width: 40px;
    object-fit: cover;
}
.star_icon {
    padding: 0.4rem;
    background-color: #fbfbf4;
}
.see_more_btn {
    font-size: 0.7rem;
    width: 50px;
    color: #1f8f58;
}
.description {
    font-size: 12px;
    color: #949494;
    white-space: normal;
    text-align: left !important;
    white-space: nowrap;
    justify-content: flex-start;
    text-overflow: ellipsis;
    overflow: hidden;
}
@media all and (max-width: 1060px) {
    .review_grid {
        grid-template-columns: none;
        grid-gap: 2px;
        background-color: white;
        width: 100%;
        justify-content: space-between;
        margin: 0.2rem;
        border-radius: 2px;
    }
}
</style>